import React from 'react';
import { LayoutList } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Checkbox } from '../ui/checkbox';
import { ADMIN_MENUS } from './constants';

// Menus du tableau de bord administrateur visibles pour ce rôle.
export const MenusSelector = ({ menus, onChange }) => {
  const selected = new Set(menus || []);
  const toggle = (value) => {
    const next = new Set(selected);
    next.has(value) ? next.delete(value) : next.add(value);
    onChange([...next]);
  };
  return (
    <Card data-testid="role-menus-selector">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <LayoutList className="h-4 w-4" /> Menus visibles ({selected.size})
        </CardTitle>
        <p className="text-xs text-slate-500">
          Seuls ces menus apparaissent dans l’espace administration (« Mon Profil » reste toujours visible).
          Pensez à cocher « Accéder au dashboard admin » dans les permissions.
        </p>
      </CardHeader>
      <CardContent className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {ADMIN_MENUS.map((m) => (
          <label key={m.value} className="flex cursor-pointer items-center gap-2 text-sm">
            <Checkbox
              checked={selected.has(m.value)}
              onCheckedChange={() => toggle(m.value)}
              data-testid={`role-menu-${m.value}`}
            />
            {m.label}
          </label>
        ))}
      </CardContent>
    </Card>
  );
};
